export function formatMoney(value, currency = "INR") {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currency || "INR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export function toDateInput(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
}

export function todayInput(offsetDays = 0) {
  const now = new Date();
  now.setDate(now.getDate() + offsetDays);
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

export function portalTone(status) {
  if (["Active", "Approved", "Resolved", "Closed", "Paid", "Shared"].includes(status)) return "success";
  if (["Pending", "Open", "In Progress", "Waiting Client", "Sent", "Draft"].includes(status)) return "warn";
  if (["Rejected", "Changes Requested", "Overdue", "Inactive", "Archived", "Cancelled"].includes(status)) return "danger";
  if (["High", "Urgent"].includes(status)) return "danger";
  if (["Medium"].includes(status)) return "warn";
  return "neutral";
}

export function ClientPortalBadge({ status }) {
  return <span className={`client-portal-badge ${portalTone(status)}`}>{status || "Not Set"}</span>;
}
